module.exports = __webpack_public_path__ + "img/Logo-header.887a31d9.png";